import { render, staticRenderFns } from "./host-supply.vue?vue&type=template&id=2f069671&scoped=true&"
import script from "./host-supply.vue?vue&type=script&lang=js&"
export * from "./host-supply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f069671",
  null
  
)

export default component.exports